export default __webpack_public_path__ + "static/media/subscription-success-icon.f08a7842.svg";